import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab-wr" }
const _hoisted_2 = { class: "tab-content" }
const _hoisted_3 = { class: "default-form" }
const _hoisted_4 = { class: "buttons-section mb-col" }
const _hoisted_5 = { class: "tab-title" }
const _hoisted_6 = { class: "buttons-section" }
const _hoisted_7 = { class: "input-wr borrow-calculator" }
const _hoisted_8 = { class: "input dropdown-input" }
const _hoisted_9 = { class: "buttons-section mb-col" }
const _hoisted_10 = { class: "buttons-section" }
const _hoisted_11 = { class: "input-wr borrow-calculator" }
const _hoisted_12 = { class: "input dropdown-input" }
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "tab-title" }, "How many people will by applying?", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["green-button-container borrow-calculator borrow-calculator borderless", $setup.props.form?.JointIncome === '0' ? 'active' : 'un-active']),
            tabindex: "0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.JOINT_INCOME, '0')))
          }, "It’s just me", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["green-button-container borrow-calculator borderless", $setup.props.form?.JointIncome === '1' ? 'active' : 'un-active']),
            tabindex: "0",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.JOINT_INCOME, '1')))
          }, "There’s two of us", 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[8] || (_cache[8] = _createTextVNode("How many dependents do you financially support?", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode($setup["DropDown"], null, {
                control: _withCtx(() => [
                  _createElementVNode("button", _hoisted_8, _toDisplayString($setup.props.form?.NoOfDependents === "3" ? "3+" : $setup.props.form?.NoOfDependents), 1)
                ]),
                dropdown: _withCtx(() => [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.NO_OF_DEPENDENTS, '0')))
                    }, "0"),
                    _createElementVNode("li", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.NO_OF_DEPENDENTS, '1')))
                    }, "1"),
                    _createElementVNode("li", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.NO_OF_DEPENDENTS, '2')))
                    }, "2"),
                    _createElementVNode("li", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.NO_OF_DEPENDENTS, '3')))
                    }, "3+")
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "tab-title" }, "Will you be living in the home?", -1)),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass(["green-button-container borrow-calculator borderless", $setup.props.formCalculatorOptions?.willLiveInHome ? 'active' : 'un-active']),
            tabindex: "0",
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.updateFormCalculatorOptions($setup.CalculatorOptionsFields.WILL_LIVE_IN_HOME, true)))
          }, "Yes, I will", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["green-button-container borrow-calculator borderless", !$setup.props.formCalculatorOptions?.willLiveInHome ? 'active' : 'un-active']),
            tabindex: "0",
            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.updateFormCalculatorOptions($setup.CalculatorOptionsFields.WILL_LIVE_IN_HOME, false)))
          }, "No, it’s an investment", 2)
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "tab-title" }, "Select your loan term.", -1)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode($setup["DropDown"], null, {
              control: _withCtx(() => [
                _createElementVNode("button", _hoisted_12, _toDisplayString($setup.props.form?.LoanTerm), 1)
              ]),
              dropdown: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.loanTermAmount, (year) => {
                    return (_openBlock(), _createElementBlock("li", {
                      onClick: ($event: any) => ($setup.updateForm($setup.BorrowCalculatorFields.LOAN_TERM, `${year} years`))
                    }, _toDisplayString(`${year} years`), 9, _hoisted_13))
                  }), 256))
                ])
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ]))
}